<!-- 建设基础数据管理 -->
<template>
  <div class="page">
    <div
      class="paginations"
      :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }"
    >
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="资源库：">
            <el-input
              size="small"
              v-model="searchData.zykName"
              placeholder="请输入资源库"
            />
          </el-form-item>
          <el-form-item label="级别：">
            <el-select
              size="small"
              placeholder="请选择级别"
              v-model="projectType"
              clearable
            >
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :value="item.value"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="资源库存储量：">
            <el-input
              size="small"
              v-model="searchData.resourceSave"
              placeholder="请输入资源库存储量"
            />
          </el-form-item>
          <el-form-item label="课程总数：">
            <el-input
              size="small"
              v-model="searchData.courseTotal"
              placeholder="请输入课程总数"
            />
          </el-form-item>
          <el-form-item label="题库总数：">
            <el-input
              size="small"
              v-model="searchData.questionCount"
              placeholder="请输入题库总数"
            />
          </el-form-item>
          <el-form-item label="用户总数：">
            <el-input
              size="small"
              v-model="searchData.userTypeNum"
              placeholder="请输入用户总数"
            />
          </el-form-item>
          <el-form-item label="参建单位教师：">
            <el-input
              size="small"
              v-model="searchData.pitchCoreTeacher"
              placeholder="请输入单位教师"
            />
          </el-form-item>
          <el-form-item label="参建单位学生：">
            <el-input
              size="small"
              v-model="searchData.pitchCoreStudent"
              placeholder="请输入参建单位学生"
            />
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
              <div class="addition">
                <el-button @click="updateData(true)"> 更新 </el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="table_box">
        <el-table
          :data="tableObj.list"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="zykName" label="资源库名称" align="center" />
          <el-table-column prop="projectTypeName" label="级别" align="center" />
          <el-table-column
            prop="resourceCount"
            label="资源总量"
            align="center"
          />
          <el-table-column
            prop="resourceSave"
            label="资源存储量"
            align="center"
          />
          <el-table-column
            prop="resourceVisit"
            label="资源访问总量"
            align="center"
          />
          <el-table-column prop="courseTotal" label="课程总数" align="center" />
          <el-table-column
            prop="questionCount"
            label="题库总数"
            align="center"
          />
          <el-table-column prop="userTypeNum" label="用户总数" align="center" />
          <el-table-column
            prop="pitchCoreTeacher"
            label="参建单位教师"
            align="center"
          />
          <el-table-column
            prop="pitchCoreStudent"
            label="参建单位学生"
            align="center"
          />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <i
                class="icona el-icon-refresh"
                title="更新"
                @click="updateData(false, [scope.row.zykid])"
              />
              <i
                class="icona el-icon-upload"
                title="导出"
                @click="exportData(scope.row)"
              />
              <i
                class="icona el-icon-view"
                title="查看详情"
                @click="viewDetail(scope.row)"
              />
            </template>
          </el-table-column>
        </el-table>
        <pageNumber
          :paginations="7"
          :pageNum="searchData.pageDto.pageNum"
          :page-size="searchData.pageDto.pageSize"
          :total="tableObj.total"
          :jumpTo="tableObj.jumpTo"
          @currentChange="search"
        ></pageNumber>
      </div>
    </div>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; //分页
export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      // 查询条件
      searchData: {
        zykName: "",
        projectType: "",
        resourceSave: "",
        courseTotal: "",
        questionCount: "",
        userTypeNum: "",
        pitchCoreTeacher: "",
        pitchCoreStudent: "",
        pageDto: {
          pageNum: 1, //当前显示的页面页码数
          pageSize: 10,
        },
      },
      projectType: "",
      // 级别
      levelList: [
        {
          value: 1,
          name: "国家级",
        },
        {
          value: 2,
          name: "省级",
        },
        {
          value: 3,
          name: "校级",
        },
      ],
      // 表格数据
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: [],
      },
      selectRowZykId: [],
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    // 查询表格
    search(page) {
      this.searchData.pageDto.pageNum = page ? page : 1;
      this.tableObj.jumpTo = page ? page : 1;
      this.searchData.projectType = this.projectType || 0;
      this.$axios
        .post(this.$apiurls.getBuildBaseManageInfo, this.searchData, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            let data = res.data.list;
            for (const obj of data) {
              let current = this.levelList.find(
                (item) => item.value == obj.projectType
              );
              if (current) obj.projectTypeName = current.name;
              let jsonData = JSON.parse(obj.jsonData);
              obj.resourceCount = jsonData.resourceBuild.resourceCount;
              obj.resourceSave = jsonData.declBuildBaseInfo.resourceSave;
              obj.resourceVisit = jsonData.resourceBuild.resourceVisit;
              obj.courseTotal =
                jsonData.declBuildBaseInfo.standardNum +
                jsonData.declBuildBaseInfo.majorCoreNum;
              obj.questionCount = jsonData.questionCount;
              let userSum = 0;
              jsonData.userTypeNum.forEach((item) => {
                userSum += item.value;
              });
              obj.userTypeNum = userSum;
              obj.pitchCoreTeacher =
                jsonData.declBuildBaseInfo.pitchCoreTeacher;
              obj.pitchCoreStudent =
                jsonData.declBuildBaseInfo.pitchCoreStudent;
            }
            this.tableObj.list = data;
            this.tableObj.total = res.data.total;
          }
        });
    },
    // 重置表格
    reset() {
      this.searchData.zykName = "";
      this.searchData.resourceSave = "";
      this.searchData.courseTotal = "";
      this.searchData.questionCount = "";
      this.searchData.userTypeNum = "";
      this.searchData.pitchCoreTeacher = "";
      this.searchData.pitchCoreStudent = "";
      this.projectType = "";
      this.search();
    },
    // 表格多选
    handleSelectionChange(val) {
      let idArr = [];
      for (const item of val) {
        idArr.push(item.zykid);
      }
      this.selectRowZykId = idArr;
    },
    // 点击更新
    updateData(flag, id) {
      if (flag) {
        if (this.selectRowZykId.length === 0)
          return this.$message.warning({
            message: "请先选择要更新的行！",
          });
        id = this.selectRowZykId;
      }
      this.$axios
        .post(this.$apiurls.initializeBuildBaseManageInfo, id, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "更新成功！",
              type: "success",
            });
            this.search();
          }
        });
    },
    // 点击导出
    exportData(item) {
      this.$axios
        .get(`${this.$apiurls.exportBuildBaseManageInfo}?zykId=${item.zykid}`, {
          loading: false,
        })
        .then((res) => {
          if (res.code === 200) {
            window.open(res.data);
          }
        });
    },
    // 点击查看详情
    viewDetail(item) {
      this.$router.push({
        path: "/monitorIndexDataTrack",
        query: {
          showExportBtn: true,
        },
      });
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/popUp.scss" scoped>
</style>
<style lang="scss" src="@/assets/css/tableList.scss" scoped>
</style>
<style lang="scss" scoped>
.paginations {
  height: 100%;
}

::v-deep .el-form {
  height: 100%;

  .el-textarea {
    .el-textarea__inner {
      font-family: initial;
    }
  }
}

.pop_up ::v-deep .el-dialog__body {
  max-height: 600px;
}

.el-tree {
  max-height: 550px;
  overflow: auto;
}

.el-tree,
::v-deep.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content,
::v-deep .el-tree-node:focus > .el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}

.table_box {
  // max-height: calc(100% - 60px);
  margin-bottom: 0;
}
</style>
<style lang="scss">
.zyk-content {
  width: calc(100% - 50px);
  margin-left: 20px;
  min-height: 100px;
  max-height: 200px;
  overflow: auto;
  border: 1px solid rgba(86, 94, 121, 0.59);
  background-color: rgba(86, 94, 121, 0.59);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 15px;

  .item {
    margin-right: 20px;
    color: #fff;
  }
}

.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: none !important;
  max-height: 268px;
  border-radius: 4px;
  background-color: rgba(26, 38, 72);
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;

  .el-select-dropdown__list {
    box-sizing: border-box;
    padding: -1px 0;
    background: rgba(26, 38, 72) !important;

    .el-select-dropdown__item {
      color: #fff !important;
    }

    .hover,
    .el-select-dropdown__item:hover {
      background: transparent;
      border: 1px solid rgba(27, 246, 248);
    }

    .el-select-dropdown__item:hover span {
      font-size: 14px;
      transform: scale(1);
    }

    .selected {
      color: rgba(27, 246, 248);
    }
  }

  .popper__arrow,
  .popper__arrow::after {
    position: absolute;
    display: "";
    width: "";
    height: "";
    border: none;
    border-style: "";
  }
}

.el-input__inner {
  background: rgba(86, 94, 121, 0.59);
  border-color: rgba(86, 94, 121, 0.59);
  color: #fff;
}

.el-icon-refresh,
.el-icon-upload,
.el-icon-view {
  font-size: 18px !important;
  color: #1bf6f8 !important;
  margin-right: 5px;
  cursor: pointer;
}
</style>
